import { MENU_ITEM_CLICK } from '.';

export default (previousState = null, { type, payload }) => {
  if (type === MENU_ITEM_CLICK) {
    return payload;
  }
  return previousState;
};
